module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/Cuisinart-e438dd6fb7b77938bb157813dcec8887.png";